// 인증 관련 API 함수
import axiosInstance from './axiosInstance';

// 로그인 요청
export const login = async (username, password) => {
  const response = await axiosInstance.post('/auth/login', { username, password });
  return response.data;
};

// 로그아웃 (로컬스토리지 정리)
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// 현재 로그인 사용자 정보 조회
export const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// 동의 내용 조회 (회원가입 화면용, 인증 불필요)
export const getAgreeMaster = (agreeType) =>
  axiosInstance.get(`/auth/agree-master/${agreeType}`).then(r => r.data);
